import timezoneMap from '../timezone-short-name-map.json' with { type: 'json' };

export const getTimezoneOffsetForDateMilliseconds = (date: number, timeZone: keyof typeof timezoneMap) => {
  const utc = new Date(new Date(date).toLocaleString('en-US', { timeZone: 'UTC' }));
  const dateObj = new Date(new Date(date).toLocaleString('en-US', { timeZone: timeZone }));
  return dateObj.getTime() - utc.getTime();
};

export const isSameDayInTimezone = (
  utcTimestamp1: number,
  utcTimestamp2: number,
  timeZone: keyof typeof timezoneMap
) => {
  const date1 = new Date(utcTimestamp1);
  const date2 = new Date(utcTimestamp2);

  // Format both dates to the target timezone and extract just the date part
  const options: Intl.DateTimeFormatOptions = {
    timeZone: timeZone,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  };

  const formatter = new Intl.DateTimeFormat('en-CA', options); // en-CA gives YYYY-MM-DD format

  const date1InTimeZone = formatter.format(date1);
  const date2InTimeZone = formatter.format(date2);

  return date1InTimeZone === date2InTimeZone;
};
